var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.817 3.654a5.211 5.211 0 0 0-2.2.858c-.428.29-1.012.884-1.311 1.333-.484.726-.803 1.575-.891 2.376l-.023.205-.272.088a4.357 4.357 0 0 0-1.674 1.029c-.705.677-1.149 1.496-1.368 2.524-.085.399-.084 1.367.001 1.766.209.975.604 1.742 1.23 2.39a4.462 4.462 0 0 0 2.436 1.331c.224.044.612.057 2.197.07l1.925.015v-3.342l-.082-.082c-.081-.081-.086-.082-.742-.082-.787-.001-.895-.03-.988-.264a.426.426 0 0 1-.034-.229c.012-.049.525-.788 1.14-1.64 1.438-1.993 1.422-1.972 1.566-2.048a.638.638 0 0 1 .576.006c.147.091 2.626 3.498 2.674 3.675a.411.411 0 0 1-.164.423c-.081.053-.19.063-.823.077-.717.017-.73.018-.793.096-.061.075-.064.155-.064 1.744v1.666l1.925-.015c2.131-.018 2.177-.022 2.842-.244.685-.229 1.236-.584 1.778-1.146a4.644 4.644 0 0 0 1.245-2.392c.082-.408.082-1.376 0-1.784a5.09 5.09 0 0 0-.728-1.775c-.231-.35-.9-1.02-1.245-1.246a4.398 4.398 0 0 0-2.132-.731l-.332-.023-.073-.385c-.401-2.124-1.918-3.717-3.98-4.181-.243-.055-1.374-.099-1.616-.063",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFill);
export default __webpack_public_path__ + "static/media/icon-upload-fill.cfc40be619e9dfc673147459fa7a463c.svg";
export { ForwardRef as ReactComponent };